module.exports = __webpack_public_path__ + "static/media/takeda.2426165d.png";